import {
  normalizeUrlPrefixCheckoutSource,
  normalizeUrlPrefixContinuePath
} from '../lib/url-prefix-continuation.js';

export type UrlPrefixJoinHeroKind =
  | 'signed-out'
  | 'signed-in'
  | 'paid'
  | 'success-confirmed';

export interface UrlPrefixJoinBootstrapLike {
  source?: unknown;
  continuePath?: unknown;
}

export interface UrlPrefixJoinContext {
  continuePath: string;
  label: string;
}

export interface UrlPrefixJoinHeroCopy {
  eyebrow?: string;
  headlineText: string;
  sub: string;
}

export function resolveUrlPrefixJoinContext(
  bootstrap: UrlPrefixJoinBootstrapLike
): UrlPrefixJoinContext | null {
  if (!normalizeUrlPrefixCheckoutSource(bootstrap.source)) {
    return null;
  }
  const continuePath = normalizeUrlPrefixContinuePath(bootstrap.continuePath);
  if (!continuePath) {
    return null;
  }
  return {
    continuePath,
    label: restoreUrlPrefixLabel(continuePath)
  };
}

export function resolveUrlPrefixJoinHeroCopy(
  kind: UrlPrefixJoinHeroKind,
  context: UrlPrefixJoinContext | null
): UrlPrefixJoinHeroCopy | null {
  if (!context) {
    return null;
  }
  switch (kind) {
    case 'signed-out':
      return {
        eyebrow: 'Saved',
        headlineText: 'Join to gist this page.',
        sub: 'Sign in, choose a plan, and Gist will continue automatically.'
      };
    case 'signed-in':
      return {
        eyebrow: 'Ready',
        headlineText: 'Choose a plan to gist this page.',
        sub: 'Your link is saved. Checkout takes a moment, then we open the gist.'
      };
    case 'paid':
    case 'success-confirmed':
      return {
        headlineText: 'Continuing your gist.',
        sub: 'Your membership is active. We\u2019re opening the page you wanted to gist.'
      };
  }
}

export function resolveUrlPrefixJoinContinuationUrl(
  joinPath: string,
  continuePath: string,
  origin: string
): string {
  const url = new URL(joinPath, origin);
  url.searchParams.set('source', 'url-prefix');
  url.searchParams.set('continue', continuePath);
  return `${url.pathname}${url.search}${url.hash}`;
}

function restoreUrlPrefixLabel(continuePath: string): string {
  try {
    const restored = continuePath.slice(1).replace(/^([a-z][a-z0-9+.-]*):\//i, '$1://');
    return new URL(restored).toString();
  } catch {
    return continuePath;
  }
}
